import { render, staticRenderFns } from "./AddBlogItem.vue?vue&type=template&id=1a6a4cc4&scoped=true"
import script from "./AddBlogItem.vue?vue&type=script&lang=js"
export * from "./AddBlogItem.vue?vue&type=script&lang=js"
import style0 from "./AddBlogItem.vue?vue&type=style&index=0&id=1a6a4cc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6a4cc4",
  null
  
)

export default component.exports